// TODO: need some help addin new / reviewing current tips :)
export const tips = [
  'Press <Ctrl> and move your mouse to see your hand',
  'Use warps to travel between rooms',
  'Double-click your head to change its shape',
  'Press the number keys for a surprise',
  'The hosts can prevent visitors from adding items in "⚙/Room Details/Permissions"',
  '"Right click" + "Lock" an element as a host to prevent it from moving',
];
